import React, { useEffect, useState } from "react";
import { supabase } from "../supabase/client";
import {
  FiMapPin,
  FiPhone,
  FiClock,
  FiToggleLeft,
  FiToggleRight,
  FiFilter,
} from "react-icons/fi";
import "./Carwashes.css";

const Carwashes = () => {
  const [carwashes, setCarwashes] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  const fetchCarwashes = async () => {
    setLoading(true);
    let query = supabase.from("carwashes").select("*");

    // Fixed filter conditions to match actual database columns
    if (filter === "active") query = query.eq("active_status", true);
    if (filter === "inactive") query = query.eq("active_status", false);
    if (filter === "open") query = query.eq("isOpen", true);
    if (filter === "closed") query = query.eq("isOpen", false);

    const { data, error } = await query;
    if (!error) setCarwashes(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchCarwashes();
  }, [filter]);

  const updateField = async (id, field, value) => {
    const { error } = await supabase
      .from("carwashes")
      .update({ [field]: value })
      .eq("id", id);

    if (!error) fetchCarwashes();
  };

  // Format time from database to readable format for time inputs
  const formatTimeForInput = (timeString) => {
    if (!timeString) return "";
    return timeString.substring(0, 5); // Extracts HH:MM from HH:MM:SS for time input
  };

  return (
    <div className="carwashes-container">
      <div className="page-header">
        <h2 className="page-title">Car Wash Locations</h2>
        <div className="filter-control">
          <FiFilter className="filter-icon" />
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Locations</option>
            <option value="active">Active Only</option>
            <option value="inactive">Inactive Only</option>
            <option value="open">Currently Open</option>
            <option value="closed">Currently Closed</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div className="loading-spinner">Loading...</div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Address</th>
                <th>
                  <FiPhone /> Phone
                </th>
                <th>
                  <FiClock /> Hours
                </th>
                <th>Status</th>
                <th>Map</th>
              </tr>
            </thead>
            <tbody>
              {carwashes.map((c) => (
                <tr key={c.id}>
                  <td>
                    <input
                      type="text"
                      value={c.name || ""}
                      onChange={(e) =>
                        updateField(c.id, "name", e.target.value)
                      }
                      className="table-input"
                      placeholder="Carwash name"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={c.address || ""}
                      onChange={(e) =>
                        updateField(c.id, "address", e.target.value)
                      }
                      className="table-input"
                      placeholder="Address"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={c.phone || ""}
                      onChange={(e) =>
                        updateField(c.id, "phone", e.target.value)
                      }
                      className="table-input"
                      placeholder="Phone number"
                    />
                  </td>
                  <td>
                    <div className="hours-input-group">
                      <input
                        type="time"
                        value={formatTimeForInput(c.open_time) || ""}
                        onChange={(e) =>
                          updateField(c.id, "open_time", e.target.value + ":00")
                        }
                        className="table-input time-input"
                      />
                      <input
                        type="time"
                        value={formatTimeForInput(c.close_time) || ""}
                        onChange={(e) =>
                          updateField(c.id, "close_time", e.target.value + ":00")
                        }
                        className="table-input time-input"
                      />
                    </div>
                  </td>
                  <td>
                    <div className="status-badges">
                      <span
                        className={`badge ${c.active_status ? "active" : "inactive"}`}
                        onClick={() =>
                          updateField(c.id, "active_status", !c.active_status)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {c.active_status ? <FiToggleRight /> : <FiToggleLeft />}
                        {c.active_status ? "Active" : "Inactive"}
                      </span>
                      <span
                        className={`badge ${c.isOpen ? "open" : "closed"}`}
                        onClick={() =>
                          updateField(c.id, "isOpen", !c.isOpen)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {c.isOpen ? "Open" : "Closed"}
                      </span>
                    </div>
                  </td>
                  <td>
                    {c.lat && c.long ? (
                      <a
                        href={`https://www.google.com/maps?q=${c.lat},${c.long}`}
                        target="_blank"
                        rel="noreferrer"
                        className="map-link"
                      >
                        <FiMapPin /> View
                      </a>
                    ) : (
                      <span className="no-map">No coordinates</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Carwashes;